<template>
  <v-app class="futuristic-app">

    <v-app-bar app flat height="74" class="layanan-header">
      <div class="header-inner">
        <v-btn icon class="back-btn" @click="$router.back()" aria-label="Kembali">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <div class="header-brand">
          <div class="brand-mark">
            <img src="/images/icon2.png" width="40" />
          </div>

          <div class="brand-copy">
            <div class="brand-name">BONDOWOSO <span>BERKAH</span></div>
            <div class="brand-tagline">Berkualitas, Akseleratif dan Holistik</div>
          </div>
        </div>

        <v-spacer />

        <div class="header-info d-none d-sm-flex">
          <div class="header-info-icon">
            <v-icon size="18" color="#018c74"> mdi-sprout-outline </v-icon>
          </div>

          <div>
            <div class="header-info-title">Komoditas Unggulan</div>
            <div class="header-info-subtitle">Peta daerah penghasil</div>
          </div>
        </div>
      </div>
    </v-app-bar>

    <v-main class="main-area">
      <v-container fluid class="px-6 fill-height align-start">
        <v-row class="fill-height mt-2" no-gutters>
          <v-col cols="12" class="fill-height">
            <v-card
              class="cyber-map-container overflow-hidden full-height-card"
              style="position: relative"
            >
              <div class="map-corners">
                <div class="c-tl"></div>
                <div class="c-tr"></div>
                <div class="c-bl"></div>
                <div class="c-br"></div>
              </div>

              <div id="map"></div>

              <div
                class="map-legend-overlay pa-3"
                :class="{ 'is-minimized': isLegendMinimized }"
              >
                <div
                  class="d-flex align-center legend-header-row"
                  :class="{ 'mb-2': !isLegendMinimized }"
                >
                  <v-icon small color="#018c74" class="mr-1">mdi-layers-outline</v-icon>
                  <div class="black--text text-overline font-weight-bold legend-title">
                    Filter Komoditas
                  </div>
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    small
                    class="minimize-btn"
                    @click="isLegendMinimized = !isLegendMinimized"
                    :aria-label="
                      isLegendMinimized ? 'Buka panel filter' : 'Tutup panel filter'
                    "
                  >
                    <v-icon>{{
                      isLegendMinimized ? "mdi-chevron-down" : "mdi-chevron-up"
                    }}</v-icon>
                  </v-btn>
                </div>

                <v-expand-transition>
                  <div v-show="!isLegendMinimized">
                    <template v-if="Object.keys(kopiConfig).length">
                      <v-btn
                        block
                        outlined
                        rounded
                        class="legend-btn text-capitalize justify-start mb-2"
                        :style="getFilterButtonStyle(activeFilter === 'kopi', '#018c74')"
                        @click="toggleFilter('kopi')"
                      >
                        <v-icon
                          left
                          :color="activeFilter === 'kopi' ? 'white' : '#018c74'"
                        >
                          {{
                            activeFilter === "kopi"
                              ? "mdi-pine-tree"
                              : "mdi-pine-tree-outline"
                          }}
                        </v-icon>
                        <span class="font-weight-bold">Komoditas Kopi</span>
                        <v-spacer></v-spacer>
                        <v-icon small :color="activeFilter === 'kopi' ? 'white' : 'grey'">
                          {{
                            activeFilter === "kopi"
                              ? "mdi-chevron-up"
                              : "mdi-chevron-down"
                          }}
                        </v-icon>
                      </v-btn>

                      <v-expand-transition>
                        <div
                          v-if="activeFilter === 'kopi'"
                          class="sub-legend-container pa-2 rounded-lg mb-2"
                        >
                          <div
                            v-for="(color, type) in kopiConfig"
                            :key="type"
                            class="d-flex align-center py-1 px-2 rounded sub-legend-item"
                          >
                            <div
                              class="legend-dot-small mr-3"
                              :style="{ background: color }"
                            ></div>
                            <div class="text-caption black--text font-weight-medium">
                              {{ type }}
                            </div>
                          </div>
                        </div>
                      </v-expand-transition>
                    </template>

                    <template v-if="Object.keys(tebuConfig).length">
                      <v-btn
                        block
                        outlined
                        rounded
                        class="legend-btn text-capitalize justify-start mb-2"
                        :style="getFilterButtonStyle(activeFilter === 'tebu', '#43A047')"
                        @click="toggleFilter('tebu')"
                      >
                        <v-icon
                          left
                          :color="activeFilter === 'tebu' ? 'white' : '#43A047'"
                        >
                          {{ activeFilter === "tebu" ? "mdi-seed" : "mdi-seed-outline" }}
                        </v-icon>
                        <span class="font-weight-bold">Komoditas Tebu</span>
                        <v-spacer></v-spacer>
                        <v-icon small :color="activeFilter === 'tebu' ? 'white' : 'grey'">
                          {{
                            activeFilter === "tebu"
                              ? "mdi-chevron-up"
                              : "mdi-chevron-down"
                          }}
                        </v-icon>
                      </v-btn>

                      <v-expand-transition>
                        <div
                          v-if="activeFilter === 'tebu'"
                          class="sub-legend-container pa-2 rounded-lg mb-2"
                        >
                          <div
                            v-for="(color, range) in tebuConfig"
                            :key="range"
                            class="d-flex align-center py-1 px-2 rounded sub-legend-item"
                          >
                            <div
                              class="legend-dot-small mr-3"
                              :style="{ background: color }"
                            ></div>
                            <div class="text-caption black--text font-weight-medium">
                              {{ range }}
                            </div>
                          </div>
                        </div>
                      </v-expand-transition>
                    </template>

                    <template v-if="Object.keys(tembakauConfig).length">
                      <div class="black--text text-overline font-weight-bold mt-2 mb-1">
                        Varietas Tembakau
                      </div>

                      <div class="d-flex flex-column gap-1">
                        <v-btn
                          v-for="(color, name) in tembakauConfig"
                          :key="name"
                          block
                          outlined
                          rounded
                          class="legend-btn text-capitalize justify-start mb-1"
                          :style="getFilterButtonStyle(activeFilter === name, color)"
                          @click="toggleFilter(name)"
                        >
                          <div
                            class="legend-dot-small mr-3"
                            :style="{
                              background: activeFilter === name ? 'white' : color,
                            }"
                          ></div>
                          <span
                            :class="
                              activeFilter === name
                                ? 'font-weight-black'
                                : 'font-weight-medium'
                            "
                          >
                            {{ name }}
                          </span>
                        </v-btn>
                      </div>
                    </template>

                    <template v-if="Object.keys(lainnyaConfig).length">
                      <div
                        v-for="(kategoriMap, jenisName) in lainnyaConfig"
                        :key="'lainnya-' + jenisName"
                      >
                        <div class="black--text text-overline font-weight-bold mt-2 mb-1">
                          {{ jenisName }}
                        </div>

                        <div class="d-flex flex-column gap-1">
                          <v-btn
                            v-for="(color, kategoriName) in kategoriMap"
                            :key="kategoriName"
                            block
                            outlined
                            rounded
                            class="legend-btn text-capitalize justify-start mb-1"
                            :style="
                              getFilterButtonStyle(activeFilter === kategoriName, color)
                            "
                            @click="toggleFilter(kategoriName)"
                          >
                            <div
                              class="legend-dot-small mr-3"
                              :style="{
                                background:
                                  activeFilter === kategoriName ? 'white' : color,
                              }"
                            ></div>
                            <span
                              :class="
                                activeFilter === kategoriName
                                  ? 'font-weight-black'
                                  : 'font-weight-medium'
                              "
                            >
                              {{ kategoriName }}
                            </span>
                          </v-btn>
                        </div>
                      </div>
                    </template>

                    <div v-if="activeFilter" class="text-center mt-2">
                      <v-btn
                        x-small
                        text
                        color="error"
                        class="text-caption"
                        @click="resetFilter"
                      >
                        <v-icon left x-small>mdi-filter-off</v-icon> Bersihkan Filter
                      </v-btn>
                    </div>

                    <v-divider class="my-2"></v-divider>

                    <div class="black--text text-overline font-weight-bold mb-1">
                      Tampilan Batas Wilayah
                    </div>

                    <v-checkbox
                      v-model="showVillageBoundary"
                      dense
                      hide-details
                      label="Batas & Nama Desa"
                      class="mt-0 mb-1 boundary-checkbox"
                      @change="toggleVillageVisibility"
                    ></v-checkbox>
                  </div>
                </v-expand-transition>
              </div>

              <div
                v-if="selectedDistrict"
                class="district-info pa-3"
                :class="{ 'is-minimized': isDistrictInfoMinimized }"
              >
                <div
                  class="d-flex align-center"
                  :class="{ 'mb-3': !isDistrictInfoMinimized }"
                >
                  <v-icon color="#018c74" small class="mr-2"> mdi-map-marker </v-icon>

                  <div class="font-weight-bold" style="font-size: 15px">
                    {{ selectedDistrict }}
                  </div>

                  <v-spacer></v-spacer>

                  <v-btn
                    icon
                    small
                    @click="isDistrictInfoMinimized = !isDistrictInfoMinimized"
                  >
                    <v-icon>
                      {{
                        isDistrictInfoMinimized ? "mdi-chevron-up" : "mdi-chevron-down"
                      }}
                    </v-icon>
                  </v-btn>
                </div>

                <v-expand-transition>
                  <div v-show="!isDistrictInfoMinimized">
                    <div class="font-weight-bold mb-2">Penghasil :</div>

                    <div class="commodity-section">
                      <div class="commodity-title">☕ Kopi</div>

                      <template v-if="selectedCommodities.kopi.length">
                        <div
                          v-for="item in selectedCommodities.kopi"
                          :key="item"
                          class="commodity-item"
                        >
                          • {{ item }}
                        </div>
                      </template>

                      <div v-else class="commodity-empty">• Tidak ada</div>
                    </div>

                    <div class="commodity-section">
                      <div class="commodity-title">🌾 Tebu</div>

                      <div v-if="selectedCommodities.tebu" class="commodity-item">
                        • Produksi {{ selectedCommodities.tebu }}
                      </div>

                      <div v-else class="commodity-empty">• Tidak ada</div>
                    </div>

                    <div class="commodity-section">
                      <div class="commodity-title">🍂 Tembakau</div>

                      <template v-if="selectedCommodities.tembakau.length">
                        <div
                          v-for="item in selectedCommodities.tembakau"
                          :key="item"
                          class="commodity-item"
                        >
                          • {{ item }}
                        </div>
                      </template>

                      <div v-else class="commodity-empty">• Tidak ada</div>
                    </div>

                    <div
                      v-for="(items, jenisName) in selectedCommodities.lainnya"
                      :key="'section-' + jenisName"
                      class="commodity-section"
                    >
                      <div class="commodity-title">🌱 {{ jenisName }}</div>

                      <div v-for="item in items" :key="item" class="commodity-item">
                        • {{ item }}
                      </div>
                    </div>
                  </div>
                </v-expand-transition>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { getPertanianKomoditas } from "@/api/androidInitApi";

export default {
  data: () => ({
    map: null,
    isDistrictInfoMinimized: false,
    geoJsonLayer: null,
    rawGeoJsonData: null,
    activeFilter: null,

    boundaryLayer: null,
    villageLayer: null,
    showVillageBoundary: false,

    isLegendMinimized: false,

    districtColorMap: {
      maesan: "#432219",
      tamanan: "#928773",
      tlogosari: "#acb5b4",
      sukosari: "#3f2822",
      pujer: "#9c9680",
      grujugan: "#12232a",
      curahdami: "#978b73",
      tenggarang: "#94856d",
      wonosari: "#b65221",
      tapen: "#593125",
      bondowoso: "#b1bbba",
      wringin: "#4e281e",
      tegalampel: "#452a23",
      klabang: "#a7b1b0",
      cermee: "#3b2620",
      prajekan: "#9f9177",
      pakem: "#b65221",
      sumberwringin: "#918972",
      ijen: "#8A9A5B",
      binakal: "#9e9784",
      "taman krocok": "#14252c",
      botolinggo: "#1a3139",
      "jambesari darus sholah": "#35211a",
      "jambesari darussholah": "#35211a",
    },

    kopiConfig: {},
    dataKopi: {},
    tebuConfig: {},
    dataTebu: {},
    tembakauConfig: {},
    dataTembakau: {},

    lainnyaConfig: {},
    dataLainnya: {},

    selectedDistrict: null,
    selectedCommodities: { kopi: [], tebu: null, tembakau: [], lainnya: {} },
  }),

  computed: {
    kopiConfigLower() {
      const map = {};
      Object.keys(this.kopiConfig).forEach((k) => {
        map[k.toLowerCase()] = this.kopiConfig[k];
      });
      return map;
    },
    tebuConfigLower() {
      const map = {};
      Object.keys(this.tebuConfig).forEach((k) => {
        map[k.toLowerCase()] = this.tebuConfig[k];
      });
      return map;
    },
  },

  async mounted() {
    this.isLegendMinimized = window.innerWidth <= 768;
    this.initMap();

    await this.loadBoundary();
    await this.loadData();
    await this.loadVillageBoundary();

    window.addEventListener("resize", this.handleMapResize);
    window.addEventListener("orientationchange", this.handleMapResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleMapResize);
    window.removeEventListener("orientationchange", this.handleMapResize);
    if (this.mapResizeObserver) this.mapResizeObserver.disconnect();
    if (this.map) this.map.remove();
  },

  methods: {
    async loadData() {
      try {
        const komoditas = await getPertanianKomoditas();

        if (komoditas) {
          if (komoditas.kopiConfig) this.kopiConfig = komoditas.kopiConfig;
          if (komoditas.dataKopi) this.dataKopi = komoditas.dataKopi;

          if (komoditas.tebuConfig) this.tebuConfig = komoditas.tebuConfig;
          if (komoditas.dataTebu) this.dataTebu = komoditas.dataTebu;

          if (komoditas.tembakauConfig) this.tembakauConfig = komoditas.tembakauConfig;
          if (komoditas.dataTembakau) this.dataTembakau = komoditas.dataTembakau;

          if (komoditas.lainnyaConfig) this.lainnyaConfig = komoditas.lainnyaConfig;
          if (komoditas.dataLainnya) this.dataLainnya = komoditas.dataLainnya;
        } else {
          console.warn("Data pertanian-komoditas tidak tersedia, menggunakan data default.");
        }

        const res = await fetch("/images/35.11_kecamatan.geojson");
        this.rawGeoJsonData = await res.json();

        this.geoJsonLayer = L.geoJson(null, {
          style: this.getFeatureStyle,
          filter: this.filterFeatures,
          onEachFeature: (feature, layer) => {
            const namaKec = feature.properties.nm_kecamatan;
            layer.bindTooltip(namaKec, {
              permanent: true,
              direction: "center",
              className: "label-kecamatan",
            });
            layer.on({
              mouseover: (e) => this.onHover(e),
              mouseout: (e) => this.onMouseOut(e),
              click: (e) => {
                this.map.fitBounds(e.target.getBounds());
                const nama = feature.properties.nm_kecamatan;
                this.selectedDistrict = nama;
                this.selectedCommodities = this.getDistrictCommodities(nama);
              },
            });
          },
        }).addTo(this.map);

        this.geoJsonLayer.addData(this.rawGeoJsonData);
      } catch (e) {
        console.error("Gagal memuat data komoditas atau GeoJSON", e);
      }
    },

    matchKec(arr, kec) {
      if (!Array.isArray(arr)) return false;
      return arr.some(
        (v) => v.toLowerCase().replace(/\s+/g, "") === kec.replace(/\s+/g, "")
      );
    },

    getDistrictCommodities(namaKec) {
      const kec = namaKec.toLowerCase().trim();

      const hasil = {
        kopi: [],
        tebu: null,
        tembakau: [],
        lainnya: {},
      };

      Object.keys(this.dataKopi).forEach((kategoriLower) => {
        if (this.matchKec(this.dataKopi[kategoriLower], kec)) {
          const labelAsli =
            Object.keys(this.kopiConfig).find((k) => k.toLowerCase() === kategoriLower) ||
            kategoriLower;
          hasil.kopi.push(labelAsli);
        }
      });

      Object.keys(this.dataTebu).forEach((range) => {
        if (this.matchKec(this.dataTebu[range], kec)) {
          hasil.tebu = range.replace(/\b\w/g, (char) => char.toUpperCase());
        }
      });

      Object.keys(this.dataTembakau).forEach((jenis) => {
        if (this.matchKec(this.dataTembakau[jenis], kec)) {
          hasil.tembakau.push(jenis.replace("Tembakau ", ""));
        }
      });

      Object.keys(this.dataLainnya).forEach((jenisBaru) => {
        const kategoriMap = this.dataLainnya[jenisBaru] || {};
        Object.keys(kategoriMap).forEach((kategori) => {
          if (this.matchKec(kategoriMap[kategori], kec)) {
            if (!hasil.lainnya[jenisBaru]) hasil.lainnya[jenisBaru] = [];
            hasil.lainnya[jenisBaru].push(kategori);
          }
        });
      });

      return hasil;
    },

    initMap() {
      this.map = L.map("map", { zoomControl: false }).setView(
        [-7.909473813658169, 113.8981324393563],
        12
      );
      L.tileLayer(
        "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
        {
          attribution: "&copy; OpenStreetMap contributors",
          maxZoom: 20,
        }
      ).addTo(this.map);
      L.control.zoom({ position: "bottomright" }).addTo(this.map);

      this.$nextTick(() => {
        setTimeout(() => {
          if (this.map) this.map.invalidateSize();
        }, 300);
      });

      const mapEl = document.getElementById("map");
      if (window.ResizeObserver && mapEl) {
        this.mapResizeObserver = new ResizeObserver(() => {
          if (this.map) this.map.invalidateSize();
        });
        this.mapResizeObserver.observe(mapEl);
      }
    },

    handleMapResize() {
      this.$nextTick(() => {
        if (this.map) this.map.invalidateSize();
      });
    },

    async loadBoundary() {
      try {
        const res = await fetch("/images/35.11_Bondowoso.geojson");
        const geojson = await res.json();
        this.boundaryLayer = L.geoJSON(geojson, {
          style: { color: "#018c74", weight: 4, opacity: 1, fillOpacity: 0 },
        }).addTo(this.map);
      } catch (e) {
        console.error("Gagal memuat batas Kabupaten Bondowoso", e);
      }
    },

    async loadVillageBoundary() {
      try {
        const res = await fetch("/images/35.11_desa.geojson");
        const geojson = await res.json();

        this.villageLayer = L.geoJSON(geojson, {
          style: {
            color: "#3E3E3E",
            weight: 1,
            opacity: 0.55,
            fillColor: "#000000",
            fillOpacity: 0,
          },
          onEachFeature: (feature, layer) => {
            const namaDesa =
              feature.properties?.nama_desa ||
              feature.properties?.NAMOBJ ||
              feature.properties?.WADMKD ||
              "Desa";
            layer.bindTooltip(namaDesa, {
              permanent: true,
              direction: "center",
              className: "label-desa",
            });
            layer.on({
              mouseover: (e) => {
                e.target.setStyle({ weight: 2, opacity: 0.9, color: "#CFA22D" });
                e.target.bringToFront();
              },
              mouseout: (e) => {
                if (this.villageLayer) this.villageLayer.resetStyle(e.target);
              },
              click: (e) => {
                L.DomEvent.stopPropagation(e);
                this.map.fitBounds(e.target.getBounds());
              },
            });
          },
        }).addTo(this.map);

        this.villageLayer.bringToFront();
        this.toggleVillageVisibility();
      } catch (e) {
        console.error("Gagal memuat batas desa", e);
      }
    },

    toggleVillageVisibility() {
      if (!this.villageLayer) return;
      if (this.showVillageBoundary) {
        if (!this.map.hasLayer(this.villageLayer)) this.villageLayer.addTo(this.map);
        this.villageLayer.bringToFront();
      } else {
        if (this.map.hasLayer(this.villageLayer)) this.map.removeLayer(this.villageLayer);
      }
    },

    filterFeatures(feature) {
      if (!this.activeFilter) return true;
      const namaKec = feature.properties.nm_kecamatan.toLowerCase().trim();

      const checkMatch = (arr) => {
        if (!Array.isArray(arr)) return false;
        return arr
          .map((v) => v.toLowerCase().replace(/\s+/g, ""))
          .includes(namaKec.replace(/\s+/g, ""));
      };

      if (this.activeFilter === "kopi") {
        return Object.values(this.dataKopi).some((arr) => checkMatch(arr));
      }

      if (this.activeFilter === "tebu") {
        return Object.values(this.dataTebu).some((arr) => checkMatch(arr));
      }

      if (this.tembakauConfig[this.activeFilter]) {
        return checkMatch(this.dataTembakau[this.activeFilter]);
      }

      for (const jenisBaru of Object.keys(this.dataLainnya)) {
        const kategoriMap = this.dataLainnya[jenisBaru] || {};
        if (kategoriMap[this.activeFilter]) {
          return checkMatch(kategoriMap[this.activeFilter]);
        }
      }

      return true;
    },

    getFeatureStyle(feature) {
      const namaKec = feature.properties.nm_kecamatan.toLowerCase().trim();
      const cleanKec = namaKec.replace(/\s+/g, "");
      let color =
        this.districtColorMap[namaKec] || this.districtColorMap[cleanKec] || "#BDBDBD";
      let fillOpacity = 0.55;

      const checkMatch = (arr) => {
        if (!Array.isArray(arr)) return false;
        return arr.map((v) => v.toLowerCase().replace(/\s+/g, "")).includes(cleanKec);
      };

      if (this.activeFilter === "kopi") {
        const matchedKey = Object.keys(this.dataKopi).find((k) =>
          checkMatch(this.dataKopi[k])
        );
        if (matchedKey) {
          color = this.kopiConfigLower[matchedKey] || "#8BC34A";
          fillOpacity = 0.8;
        }
      } else if (this.activeFilter === "tebu") {
        const matchedKey = Object.keys(this.dataTebu).find((k) =>
          checkMatch(this.dataTebu[k])
        );
        if (matchedKey) {
          color = this.tebuConfigLower[matchedKey] || "#4CAF50";
          fillOpacity = 0.8;
        }
      } else if (this.tembakauConfig[this.activeFilter]) {
        if (checkMatch(this.dataTembakau[this.activeFilter])) {
          color = this.tembakauConfig[this.activeFilter];
          fillOpacity = 0.85;
        }
      } else if (this.activeFilter) {
        for (const jenisBaru of Object.keys(this.dataLainnya)) {
          const kategoriMap = this.dataLainnya[jenisBaru] || {};
          if (
            kategoriMap[this.activeFilter] &&
            checkMatch(kategoriMap[this.activeFilter])
          ) {
            color = (this.lainnyaConfig[jenisBaru] || {})[this.activeFilter] || "#9E9E9E";
            fillOpacity = 0.85;
            break;
          }
        }
      }

      return {
        fillColor: color,
        fillOpacity: fillOpacity,
        color: "#c8c4c4",
        weight: 3.5,
        opacity: 1,
        lineJoin: "round",
      };
    },

    toggleFilter(filterType) {
      this.activeFilter = this.activeFilter === filterType ? null : filterType;
      this.refreshMapLayers();
    },
    resetFilter() {
      this.activeFilter = null;
      this.refreshMapLayers();
    },
    refreshMapLayers() {
      if (this.geoJsonLayer && this.rawGeoJsonData) {
        this.geoJsonLayer.clearLayers();
        this.geoJsonLayer.addData(this.rawGeoJsonData);
        const bounds = this.geoJsonLayer.getBounds();
        if (bounds.isValid())
          this.map.flyToBounds(bounds, { animate: true, duration: 1 });
        if (this.villageLayer && this.map.hasLayer(this.villageLayer))
          this.villageLayer.bringToFront();
      }
    },
    getFilterButtonStyle(isActive, baseColor) {
      return {
        borderColor: baseColor + " !important",
        backgroundColor: isActive
          ? baseColor + " !important"
          : "rgba(255, 255, 255, 0.85) !important",
        color: isActive ? "white !important" : "var(--text-primary) !important",
        height: "38px",
      };
    },
    onHover(e) {
      const layer = e.target;
      layer.setStyle({ fillOpacity: 0.95, weight: 4 });
    },
    onMouseOut(e) {
      if (this.geoJsonLayer) this.geoJsonLayer.resetStyle(e.target);
    },
  },
};
</script>

<style scoped>
.district-info {
  position: absolute;
  right: 20px;
  bottom: 20px;
  width: 330px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border-radius: 16px;
  border: 1px solid rgba(1, 140, 116, 0.25);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.2);
  z-index: 999;
  transition: 0.25s;
}

.district-info.is-minimized {
  width: auto;
  padding: 8px 12px !important;
  border-radius: 999px;
}

.commodity-section {
  margin-bottom: 14px;
}

.commodity-title {
  font-weight: 700;
  color: #018c74;
  margin-bottom: 6px;
}

.commodity-item {
  margin-left: 18px;
  margin-bottom: 3px;
}

.commodity-empty {
  margin-left: 18px;
  color: #9e9e9e;
  font-style: italic;
}

:root {
  --bg-teal-dark: #1a5f52;
  --bone-white: #f5f5f5;
  --text-primary: #2e2e2e;
  --accent-gold: #cfa22d;
  --accent-teal: #018c74;
}

.full-height-card {
  height: calc(100vh - 140px);
  height: calc(100dvh - 140px);
  min-height: 650px;
}
#map {
  height: 100%;
  width: 100%;
  min-height: 280px;
  background: var(--bg-teal-dark);
}

.cyber-map-container {
  border: 1px solid rgba(1, 140, 116, 0.35) !important;
  border-radius: 24px !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2) !important;
}

.map-legend-overlay {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 999;
  width: 330px;
  max-height: calc(100% - 40px);
  overflow-y: auto;
  background: rgba(250, 250, 250, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  border: 1px solid rgba(1, 140, 116, 0.3);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);
  transition: width 0.25s ease, padding 0.25s ease, max-height 0.25s ease;
}

.map-legend-overlay.is-minimized {
  width: auto;
  max-height: none;
  overflow: visible;
  padding: 6px 10px !important;
  border-radius: 999px;
}

.legend-header-row {
  cursor: pointer;
}

.legend-title {
  white-space: nowrap;
}

.map-legend-overlay.is-minimized .legend-title {
  font-size: 11px;
}

.minimize-btn {
  flex-shrink: 0;
}

.legend-btn {
  text-transform: none !important;
  font-size: 12px !important;
  transition: all 0.2s ease-in-out;
}

.sub-legend-container {
  background: rgba(0, 0, 0, 0.04);
  border: 1px dashed rgba(0, 0, 0, 0.1);
}

.sub-legend-item:hover {
  background: rgba(255, 255, 255, 0.7);
}

.legend-dot-small {
  width: 11px;
  height: 11px;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.boundary-checkbox ::v-deep .v-label {
  font-size: 12.5px;
  color: var(--text-primary);
}

.map-corners div {
  position: absolute;
  width: 30px;
  height: 30px;
  border: 3px solid var(--accent-gold);
  z-index: 10;
  pointer-events: none;
}
.c-tl {
  top: 15px;
  left: 15px;
  border-right: 0;
  border-bottom: 0;
}
.c-tr {
  top: 15px;
  right: 15px;
  border-left: 0;
  border-bottom: 0;
}
.c-bl {
  bottom: 15px;
  left: 15px;
  border-right: 0;
  border-top: 0;
}
.c-br {
  bottom: 15px;
  right: 15px;
  border-left: 0;
  border-top: 0;
}

::v-deep .label-kecamatan {
  background: rgba(255, 255, 255, 0.7) !important;
  border: none !important;
  box-shadow: none !important;
  color: #111 !important;
  font-size: 11px !important;
  font-weight: 800 !important;
  padding: 2px 6px !important;
  border-radius: 8px;
  text-transform: uppercase;
  backdrop-filter: blur(4px);
}

::v-deep .label-desa {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: #ffffff !important;
  font-size: 9px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  opacity: 1 !important;
  white-space: nowrap !important;
  text-shadow: -1px -1px 0 rgba(0, 0, 0, 0.85), 1px -1px 0 rgba(0, 0, 0, 0.85),
    -1px 1px 0 rgba(0, 0, 0, 0.85), 1px 1px 0 rgba(0, 0, 0, 0.85),
    0px 0px 3px rgba(0, 0, 0, 0.7);
}

@media (max-width: 768px) {
  .map-legend-overlay {
    width: 270px;
    top: 12px;
    left: 12px;
  }

  .map-legend-overlay.is-minimized {
    width: auto;
  }

  ::v-deep .label-desa {
    font-size: 7px !important;
  }}

.district-info {
  position: absolute;
  right: 20px;
  bottom: 20px;
  width: 280px;
  z-index: 999;
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
}


.futuristic-app {
  background: #f6f9f9 !important;
}

.main-area {
  background: radial-gradient(circle at 90% 5%, rgba(1, 140, 116, 0.035), transparent 25%),
    #f6f9f9;
}

.layanan-header {
  background: rgba(255, 255, 255, 0.94) !important;

  backdrop-filter: blur(18px);

  border-bottom: 1px solid rgba(1, 140, 116, 0.08) !important;

  z-index: 20 !important;
}

.header-inner {
  width: 100%;
  max-width: 1280px;

  margin: 0 auto;

  display: flex;
  align-items: center;
}

.back-btn {
  width: 42px !important;
  height: 42px !important;

  background: #f1f6f5;
  margin-right: 10px;
}

.back-btn:hover {
  background: #e8f5f2;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-mark {
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;

  background: linear-gradient(135deg, #e4f6f1, #f5fbf9);

  border: 1px solid rgba(1, 140, 116, 0.1);
}

.brand-name {
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.5px;
  color: #17423b;
  line-height: 1.1;
}

.brand-name span {
  color: #018c74;
}

.brand-tagline {
  font-size: 9px;
  color: #8a969b;
  margin-top: 3px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.header-info > div:last-child {
  min-width: 0;
}

.header-info-icon {
  width: 36px;
  height: 36px;

  border-radius: 10px;

  background: #f1faf8;

  display: flex;
  align-items: center;
  justify-content: center;
}

.header-info-title {
  font-size: 12px;
  font-weight: 800;
  color: #34514c;
}

.header-info-subtitle {
  max-width: 260px;

  font-size: 10px;
  color: #929da1;
  margin-top: 1px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-search {
  max-width: 300px;
}

.header-search-wrap {
  min-width: 0;
}

.header-search ::v-deep .v-input__slot,
.cyber-search-dropdown ::v-deep .v-input__slot {
  min-height: 42px !important;

  background: #f1f6f5 !important;

  border: 1px solid rgba(1, 140, 116, 0.12) !important;

  box-shadow: none !important;

  transition: all 0.25s ease;
}

.header-search ::v-deep .v-input__slot:focus-within,
.cyber-search-dropdown ::v-deep .v-input__slot:focus-within {
  background: #ffffff !important;

  border-color: #018c74 !important;
}

.header-search ::v-deep .v-icon,
.cyber-search-dropdown ::v-deep .v-icon {
  color: #018c74;
}

@media (max-width: 600px) {
  .header-inner {
    padding: 0 8px;
  }

  .brand-mark {
    width: 35px;
    height: 35px;
  }

  .brand-name {
    font-size: 12px;
  }

  .brand-tagline {
    font-size: 8px;
  }
}
</style>
